import { styled } from '@mui/material/styles';
import { Input } from 'components/ui';

export const SummaryRenameDialogField = styled('div')(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(1),
  minWidth: theme.spacing(48),
}));

export const SummaryRenameDialogLabel = styled('label')(({ theme }) => ({
  color: theme.palette.neutral[600],
  fontSize: 'var(--dialog-description-font-size)',
  fontWeight: theme.typography.fontWeightMedium,
  lineHeight: 'var(--dialog-description-line-height)',
}));

// The bare `Input` primitive is styled for page forms (14px radius, no dialog type scale), so it
// needs the dialog's own `--dialog-*` variables to sit correctly inside a Dialog. These overrides
// are deliberately duplicated from the equivalent input in FirmDocuments rather than imported:
// reaching across into that feature's styles to share them would couple Intelligence to Documents.
export const SummaryRenameDialogInput = styled(Input)(({ theme }) => ({
  '&& .MuiOutlinedInput-root': {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 'var(--dialog-select-trigger-radius)',
    color: theme.palette.neutral[900],
    fontSize: 'var(--dialog-description-font-size)',
    lineHeight: 'var(--dialog-description-line-height)',
    minHeight: 'var(--dialog-select-trigger-height)',
    padding: 0,
  },
  '&& .MuiOutlinedInput-input': {
    boxSizing: 'border-box',
    fontSize: 'var(--dialog-description-font-size)',
    lineHeight: 'var(--dialog-description-line-height)',
    padding: theme.spacing(2),
    '&::placeholder': {
      color: theme.palette.neutral[500],
      opacity: 1,
    },
  },
  '&& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.neutral[300],
    borderWidth: 'var(--dialog-border-width)',
  },
  '&& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.neutral[400],
  },
  '&& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.brand[400],
    borderWidth: 'var(--dialog-border-width)',
  },
  '&& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline, && .MuiOutlinedInput-root.Mui-error:hover .MuiOutlinedInput-notchedOutline, && .MuiOutlinedInput-root.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.red[500],
    borderWidth: 'var(--dialog-border-width)',
  },
  '&& .MuiOutlinedInput-root.Mui-disabled': {
    backgroundColor: theme.palette.action.disabledBackground,
    color: theme.palette.action.disabled,
  },
  '&& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.neutral[200],
  },
  '&& .MuiFormHelperText-root': {
    color: theme.palette.neutral[500],
    fontSize: 'var(--dialog-description-font-size)',
    lineHeight: 'var(--dialog-description-line-height)',
    marginLeft: 0,
    // Reserve the row so the dialog does not resize as the helper text appears and clears.
    minHeight: 'var(--dialog-description-line-height)',
  },
  '&& .MuiFormHelperText-root.Mui-error': {
    color: theme.palette.red[600],
  },
}));
